

























import Vue from 'vue'
import Drawer from '@/components/Global/Drawer.vue'
import { apiLinkEntitiesToBusiness } from '@/api'
import { mutations } from '@/state'

export default Vue.extend({
  name: 'LinkVendor',
  components: { Drawer },
  props: {
    businesses: Array,
    selectedEntities: Array,
    linkEntityDrawerOpened: Boolean
  },
  data () {
    return {
      selectedBusiness: null,
      drawerActive: false
    }
  },
  methods: {
    close () {
      this.$emit('closeDrawer')
    },
    async linkEntities () {
      const { id } = this.selectedBusiness
      try {
        mutations.setSnackbar()
        await apiLinkEntitiesToBusiness(id, { entities: this.selectedEntities })
        mutations.setSnackbar('success', this.t({
          s: 'success',
          component: 'Snackbar'
        }))
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      } finally {
        this.close()
        this.$emit('initialize')
      }
    }
  },
  watch: { linkEntityDrawerOpened (val) { this.drawerActive = val } }
})
